"use client";

import { AnimatePresence, m } from "motion/react";

interface BurnMultiplierProps {
  burnStreak: number;
  showMultiplier: boolean;
}

// AFTER HOURS: combo readout reads as a brief cobalt screen-flash, not
// a celebratory amber/orange/yellow burst. Removes per-tier chromatic
// halos, breathing scale pulses, and gradient-text — replaced with
// cobalt-tinted moondust on a TICKER-vocab background. The burn flow
// (multiplier escalation) is preserved; only the chrome is treated.
export function BurnMultiplier({ burnStreak, showMultiplier }: BurnMultiplierProps) {
  if (!showMultiplier || burnStreak < 2) {
    return null;
  }

  const getComboText = () => {
    if (burnStreak >= 10) return "MAX";
    if (burnStreak >= 8) return "EPIC";
    if (burnStreak >= 5) return "COMBO";
    return "";
  };

  return (
    <AnimatePresence>
      <m.div
        className="absolute -right-16 top-[45%] z-40"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.166, ease: "linear" }}
      >
        <div className="relative z-10 inline-block">
          <span
            className="kansei-flicker-living-c relative font-pressStart2P text-3xl font-bold"
            style={{
              color: "rgba(155, 176, 240, 0.92)",
              textShadow: "0 1px 0 rgba(0, 0, 0, 0.7), 0 0 1px rgba(94, 123, 250, 0.3)",
              display: "inline-block",
            }}
          >
            {burnStreak}x
          </span>
        </div>

        {burnStreak >= 5 && (
          <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 z-10">
            <span
              className="kansei-flicker-b block whitespace-nowrap font-pressStart2P text-[10px] uppercase tracking-[0.18em]"
              style={{
                color: "rgba(155, 176, 240, 0.85)",
                textShadow: "0 1px 0 rgba(0, 0, 0, 0.7)",
              }}
            >
              {getComboText()}
            </span>
          </div>
        )}
      </m.div>
    </AnimatePresence>
  );
}
